import { render, staticRenderFns } from "./SharedField.vue?vue&type=template&id=85f588e6&scoped=true"
import script from "./SharedField.vue?vue&type=script&lang=js"
export * from "./SharedField.vue?vue&type=script&lang=js"
import style0 from "./SharedField.vue?vue&type=style&index=0&id=85f588e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f588e6",
  null
  
)

export default component.exports